import { Component, OnInit } from '@angular/core';
import { AppConfigService } from 'src/app/shared/services/app-config.service';
import { PortalCredentialGroupResultModel } from './credentials.models';
import { CredentialStatusLabelColor } from 'src/app/shared/models/credential/customPersonCredentialStatusDefinition.model';
import { CredentialsService } from './credentials.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-credentials',
  templateUrl: './credentials.component.html',
  styleUrls: ['./credentials.component.scss'],
})
export class CredentialsComponent implements OnInit {
  credentialGroupResults: PortalCredentialGroupResultModel[] = [];
  CredentialStatusLabelColor = CredentialStatusLabelColor;
  loading = true;
  constructor(
    private credentialsService: CredentialsService,
    private appConfigService: AppConfigService,
    private router: Router
  ) {}
  async ngOnInit(): Promise<void> {
    if (
      this.appConfigService.tenant.portalConfiguration &&
      this.appConfigService.tenant.portalConfiguration.showCredentialTab !== true
    ) {
      this.router.navigate(['portal/not-found'], {
        skipLocationChange: true,
      });
    }
    this.credentialGroupResults = await this.credentialsService.getLicenses();
    this.loading = false;
  }
}
